import {
    createFeatureFlagSelector,
    featureFlagFind,
} from "../../selectors/featureFlag";
import { useSelector } from "react-redux";

/**
 * creates a react hook for feature flags.
 * @return react hook which returns the featureflag value.
 */

export const createUseFeatureFlagBySection = (feature) => {
    const pathSelector = createFeatureFlagSelector(feature);
    return () => {
        const section =
            useSelector((state) => state && state.app && state.app.section) ||
            "";
        const list = useSelector(pathSelector);
        return featureFlagFind(section, list);
    };
};

/**
 * a react hook for feature flags without section.
 * @param {string} flag - the name of the feature flag being retrieved
 * @return the value of the flag
 */

export const useFeatureFlag = (flag) => {
    const flags = useSelector((state) => state.featureflags) || {};
    return flags.hasOwnProperty(flag) ? flags[flag] : false;
};
